import {
  MARKETING_EMAIL_TYPE_ID,
  LANDING_PAGE_TYPE_ID,
  BLOG_POST_TYPE_ID,
  SITE_PAGE_TYPE_ID,
  KNOWLEDGE_ARTICLE_TYPE_ID,
  SOCIAL_BROADCAST_TYPE_ID,
  DEAL_TYPE_ID,
  QUOTE_TYPE_ID,
} from 'customer-data-objects/constants/ObjectTypeIds';

import type { ApprovalType } from '../types/ApprovalType';

const CONNECTED_APP_TYPE_ID = '0-620';

export const APPROVAL_TYPE_TO_OBJECT_TYPE_ID: Record<ApprovalType, string> = {
  MARKETING_EMAIL: MARKETING_EMAIL_TYPE_ID,
  LANDING_PAGE: LANDING_PAGE_TYPE_ID,
  BLOG_POST: BLOG_POST_TYPE_ID,
  SITE_PAGE: SITE_PAGE_TYPE_ID,
  KNOWLEDGE_ARTICLE: KNOWLEDGE_ARTICLE_TYPE_ID,
  SOCIAL_BROADCAST: SOCIAL_BROADCAST_TYPE_ID,
  DEAL: DEAL_TYPE_ID,
  QUOTE: QUOTE_TYPE_ID,
  CONNECTED_APP: CONNECTED_APP_TYPE_ID,
};
